import React, { useState, useEffect } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { loginRequest, checkAuth } from '../../api/auth';
import logo from '../../assets/icon.png';
//import '../styles/Login.css';
import { notify } from '../../utils/notification';

function Login(props) {
    const emailRef = React.useRef(null);
    const passwordRef = React.useRef(null);
    const [redirect, setRedirect] = useState(false);
    const navigate = useNavigate();

    useEffect(()=> {
        if (localStorage.getItem('user')) {
            checkAuth().then(res => {
                if (res.success) setRedirect(true)
                    else return;
            })
        }
    }, []);

    const onEnterKey = async (event) => {
    
        if (event.charCode === 13) {
            let email = emailRef.current.value;
            let password = passwordRef.current.value;
            
            if (!email || !password) return notify('danger', 'Missing Fields', 'Please fill out all required fields.');

            const response = await loginRequest(email, password);
            console.log(response)
            if (response.error) return notify('danger', 'Login Failed', response.error);

            //localStorage.setItem('user', JSON.stringify(response.success.user));
            //dispatch({ type: 'LOGIN', data: response.success.user});
            //props.login(response.success.user);
            setRedirect(true);
            return;
        }
    };

    return (
        <div className="relative font-sans text-primaryText overflow-hidden w-full h-full">
            {redirect ? window.location.href = process.REACT_APP_FRONT_END : null}
            <div className="m-auto w-3/4 max-w-sm bg-onPrimaryBg h-2/5 rounded-md px-10 py-8 fixed top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2">
                <div className="grid grid-cols-1 space-y-5 w-full ml-auto mr-auto m-auto px-10 py-8 fixed top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2">
                    <img className="inline ml-auto mr-auto w-24" src={logo} />
                    <input 
                        ref={emailRef}
                        placeholder="Email"
                        spellcheck="false"
                        id="newIp"
                        onKeyPress={onEnterKey} 
                        autoFocus 
                        className="pt-2 rounded-md bg-onPrimaryBg text-onPrimaryBgSofter focus:outline-none outline-none placeholder-onPrimaryBgSofter w-full" 
                        //onChange={(e)=> setEmail(emailRef.current.value)}
                    />
                    <input 
                        ref={passwordRef}
                        type="password"
                        placeholder="Password"
                        id="newIp"
                        onKeyPress={onEnterKey}
                        className="rounded-md bg-onPrimaryBg text-onPrimaryBgSofter focus:outline-none outline-none placeholder-onPrimaryBgSofter w-full" 
                        //onChange={(e)=> setPassword(passwordRef.current.value)}
                    />
                    
                    <button onClick={()=> onEnterKey({charCode: 13})} className="font-medium p-1 bg-gradient-to-r from-primary to-secondary shadow-md rounded-md text-lg focus:outline-none outline-none hover:opacity-70 transition duration-300">
                    Login
                    </button>
                    <div className="grid-rows-1 flex flex-wrap content-evenly">
                        <button onClick={() => navigate('/register')} className="focus:outline-none outline-none hover:opacity-70 transition duration-300 mr-auto ml-auto">
                            <text class="buttonText text-xs opacity-60">Create account</text>
                        </button>
                        <button onClick={() => navigate('/reset-password')} className="focus:outline-none outline-none hover:opacity-70 transition duration-300 mr-auto ml-auto">
                            <text class="buttonText text-xs opacity-60">Forgot password?</text>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Login;